import { STATS } from '../content/site';

export default function StatsStrip() {
  return (
    <section aria-label="ISL Tech in numbers" className="border-b-2 border-ink bg-accent text-ink">
      <dl className="container-site grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 200px), 1fr))' }}>
        {STATS.map((s, k) => (
          <div key={s.label} className={`flex flex-wrap items-baseline gap-x-3.5 gap-y-1 py-[22px] ${k === 0 ? 'pr-4' : 'px-4 nav:border-l-2 nav:border-ink'}`}>
            <dd className={`order-1 text-stat ${s.nowrap ? 'whitespace-nowrap' : ''}`}>{s.value}</dd>
            <dt className="order-2 text-[14px] font-semibold">{s.label}</dt>
          </div>
        ))}
      </dl>
    </section>
  );
}
